/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
import type { ReelSessionFilters } from '../model/sessionFilters';

export const REEL_SESSION_QUERY_KEYS = {
  all: ['reel-sessions'] as const,
  lists: (workspaceId: string) => [...REEL_SESSION_QUERY_KEYS.all, workspaceId, 'list'] as const,
  list: (workspaceId: string, filters: ReelSessionFilters = {}) =>
    [...REEL_SESSION_QUERY_KEYS.lists(workspaceId), filters] as const,
  allCounts: (workspaceId: string) =>
    [...REEL_SESSION_QUERY_KEYS.all, workspaceId, 'counts'] as const,
  counts: (workspaceId: string, filters: Pick<ReelSessionFilters, 'search' | 'status'> = {}) =>
    [...REEL_SESSION_QUERY_KEYS.allCounts(workspaceId), filters] as const,
  detail: (workspaceId: string, sessionId: string) =>
    [...REEL_SESSION_QUERY_KEYS.all, workspaceId, 'detail', sessionId] as const,
  storyboard: (workspaceId: string, sessionId: string) =>
    [...REEL_SESSION_QUERY_KEYS.all, workspaceId, 'storyboard', sessionId] as const,
  video: (workspaceId: string, sessionId: string) =>
    [...REEL_SESSION_QUERY_KEYS.all, workspaceId, 'video', sessionId] as const,
  characterVariations: (workspaceId: string, sessionId: string) =>
    [...REEL_SESSION_QUERY_KEYS.all, workspaceId, 'character-variations', sessionId] as const,
  studio: (workspaceId: string, sessionId: string) =>
    [...REEL_SESSION_QUERY_KEYS.all, workspaceId, 'studio', sessionId] as const,
  latestExport: (workspaceId: string, sessionId: string) =>
    [...REEL_SESSION_QUERY_KEYS.all, workspaceId, 'latest-export', sessionId] as const,
  render: (workspaceId: string, sessionId: string, renderId: string) =>
    [...REEL_SESSION_QUERY_KEYS.all, workspaceId, 'render', sessionId, renderId] as const,
  videoVersions: (workspaceId: string, sessionId: string) =>
    [...REEL_SESSION_QUERY_KEYS.video(workspaceId, sessionId), 'versions'] as const,
  shots: (workspaceId: string, sessionId: string) =>
    [...REEL_SESSION_QUERY_KEYS.video(workspaceId, sessionId), 'shots'] as const,
  shotVersions: (workspaceId: string, sessionId: string, sceneId: string) =>
    [...REEL_SESSION_QUERY_KEYS.shots(workspaceId, sessionId), 'versions', sceneId] as const,
  frameVersions: (workspaceId: string, sessionId: string, sceneId: string) =>
    [
      ...REEL_SESSION_QUERY_KEYS.storyboard(workspaceId, sessionId),
      'frame-versions',
      sceneId,
    ] as const,
  chipVersions: (workspaceId: string, sessionId: string, chipKey: string) =>
    [
      ...REEL_SESSION_QUERY_KEYS.storyboard(workspaceId, sessionId),
      'chip-versions',
      chipKey,
    ] as const,
};
